import React from "react";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import toast from "react-hot-toast";
import { useUnosPanelAdd } from "hooks/unos/panel/useUnosPanelAdd";
import { QUERY_KEYS } from "constant/react_query";
import PanelForm from "components/common/panel/PanelForm/PanelForm";
import { useNavigate } from "react-router-dom";
import { panelFormDefaultValuesGet } from "common/panel/panel_form_common";

const PanelNew = () => {
  const { handleSubmit, reset, control, setValue } = useForm({
    defaultValues: panelFormDefaultValuesGet(),
  });
  const navigate = useNavigate();
  const { panelAddMutate } = useUnosPanelAdd({
    invalidateKeys: [QUERY_KEYS.UNOS_PANEL_SEARCH],
    successHandle: (id: any) => {
      console.log("add success", id);
      navigate(`/panel/${id}`);
    },
  });

  const onSubmit = async (data: any) => {
    console.log(data);
    const { datum, title, slug, fileName } = data;

    console.log("datum", datum);
    const res = panelAddMutate({ datum, title, slug, fileName });
    toast.success("New panel added");
  };

  return (
    <>
      <div>Panel Add</div>
      <DivPanel>
        <PanelForm
          control={control}
          onSubmit={onSubmit}
          handleSubmit={handleSubmit}
          reset={reset}
          setValue={setValue}
        />
      </DivPanel>
    </>
  );
};

const DivPanel = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  column-gap: 2rem;
  row-gap: 2rem;
  margin-top: 2rem;
`;

export default PanelNew;
